import { Button, Box, Typography, useTheme } from "@mui/material";

import muiCustomStyles from "./styles/styles";

import GenericSwiperDialog from "../../../Components/Modals/GenericSwiperDialog";

import { useTranslation } from "react-i18next";



const UpdateLeft = () => {

  const { t, i18n } = useTranslation("update-popup");

  const isHebrew = i18n.language === "he";

  const {

    leftBox,

    leftInnerBox,

    leftTextWrapper,

    leftSubText,

    smallScreenHeading,

  } = muiCustomStyles;



  return (

    <Box

      sx={{

        ...leftBox,

        maxWidth: { xs: "100%", sm: "410px" },

        display: { xs: "flex", sm: "block" },

        flexDirection: "column",

      }}

    >

      <Box

        sx={{

          width: "140px",

          height: "140px",

          position: { xs: "absolute", sm: "relative" },

          top: 0,

          left: 0,

        }}

      >

        <img

          src="/images/updates-alert-img.png"

          alt="updates-alert-img"

          width="100%"

          height="100%"

          style={{ transform: isHebrew ? "scaleX(-1)" : "" }}

        />

      </Box>

      <Box

        sx={{

          ...leftInnerBox,

          mt: { xs: "0px", sm: "-32px" },

          mb: { xs: "0px", sm: "24px" },

          flex: 1,

          display: "flex",

          alignItems: "center",

        }}

      >

        <Box sx={{ ...leftTextWrapper, maxWidth: { xs: "100%", sm: "309px" } }}>

          <Box sx={{ display: { xs: "flex", sm: "none" } }}>

            <Typography color="rgba(62, 63, 76, 1)" sx={smallScreenHeading}>

              {`${t("updateTitle")}!`}

            </Typography>

          </Box>

          <Typography

            color="rgba(62, 63, 76, 1)"

            sx={{ fontSize: "18px", fontWeight: 600 }}

          >

            {t("updateHeading")}

          </Typography>

          <Typography

            color="rgba(47, 43, 61, 0.9)"

            sx={{ ...leftSubText, fontWeight: 400 }}

          >

            {t("updateParagraph")}

          </Typography>

        </Box>

      </Box>

    </Box>

  );

};



const UpdateRight = ({ onClose, isCommunityManagementRole }) => {

  const { t } = useTranslation("update-popup");

  const theme = useTheme();

  const {

    rightBox,

    rightScrollBox,

    rightTextWrapper,

    buttonWrapper,

    gotItButton,

    updateImage,

  } = muiCustomStyles;



  const updatesData = isCommunityManagementRole

    ? adminUpdatesData(t)

    : supplierUpdatesData(t);



  return (

    <Box sx={rightBox}>

      <Box sx={rightScrollBox}>

        <Box sx={{ ...rightTextWrapper, maxWidth: "632px" }}>

          <Box sx={{ display: "flex", flexDirection: "column", gap: "40px" }}>

            {updatesData.map((item, index) => (

              <Box

                sx={{

                  display: "flex",

                  gap: { xs: "16px", sm: "30px" },

                  flexDirection: { sm: "column", md: "row" },

                  alignItems: { md: "flex-start" },

                  [theme.breakpoints.down("400")]: {

                    flexDirection: "column",

                  },

                }}

                key={index}

              >

                <Box sx={{ ...updateImage, order: { sm: 2, md: 1 } }}>

                  <img

                    src="/images/features.png"

                    alt="updates-img"

                    width="100%"

                    height="100%"

                    style={{

                      borderRadius: "6px",

                      objectFit: "cover",

                    }}

                  />

                </Box>

                <Box sx={{ flex: 1, order: { sm: 1, md: 2 } }}>

                  <Typography

                    color="rgba(62, 63, 76, 1)"

                    sx={{

                      fontSize: "18px",

                      fontWeight: 600,

                      mb: { xs: "8px", sm: "14px" },

                    }}

                  >

                    {item.updateTitle}

                  </Typography>

                  <Typography

                    color="rgba(47, 43, 61, 0.9)"

                    sx={{ fontSize: "15px", fontWeight: 400 }}

                  >

                    {item.updateContent}

                  </Typography>

                </Box>

              </Box>

            ))}

          </Box>

        </Box>

      </Box>



      <Box sx={{ ...buttonWrapper, display: { xs: "none", sm: "flex" } }}>

        <Button onClick={onClose} sx={gotItButton}>

          {t("gotItButton")}

        </Button>

      </Box>

    </Box>

  );

};



const UpdatePopup = ({ open, onClose, isCommunityManagementRole }) => {

  const { t } = useTranslation("update-popup");

  return (

    <GenericSwiperDialog

      open={open}

      onClose={onClose}

      dialogBoxSx={{

        height: { xs: "100%", sm: "min(600px, calc(100dvh - 64px))" },

        minHeight: { xs: "600px", sm: "auto" },

        flex: "auto",

      }}

      dialogContentBoxSx={{

        flex: 1,

        display: "flex",

      }}

      dialogTitle={t("updateTitle")}

      leftContent={<UpdateLeft />}

      rightContent={<UpdateRight {...{ isCommunityManagementRole, onClose }} />}

    />

  );

};



export default UpdatePopup;



const adminUpdatesData = (t) => [

  {

    updateTitle: t("admin.updateTitle1"),

    updateContent: t("admin.update1"),

  },

  {

    updateTitle: t("admin.updateTitle2"),

    updateContent: t("admin.update2"),

  },

  {

    updateTitle: t("admin.updateTitle3"),

    updateContent: t("admin.update3"),

  },

  {

    updateTitle: t("admin.updateTitle4"),

    updateContent: t("admin.update4"),

  },

];



const supplierUpdatesData = (t) => [

  {

    updateTitle: t("supplier.updateTitle1"),

    updateContent: t("supplier.update1"),

  },

  {

    updateTitle: t("supplier.updateTitle2"),

    updateContent: t("supplier.update2"),

  },

];

